import jwtAuthAxios from "./auth/jwtAuth";

// «Mi perfil»: los datos de quien tiene la sesión, con cualquier perfil.
const accountServices = {};

accountServices.getAccount = async () => {
    const {data} = await jwtAuthAxios.get('/account');
    return data;
};

accountServices.saveAccount = async (account) => {
    const {data} = await jwtAuthAxios.patch('/account', { account });
    return data;
};

accountServices.changePassword = async (passwords) => {
    await jwtAuthAxios.patch('/account/password', { account: passwords });
};

// Verificación del teléfono por WhatsApp. Sin alertas: el diálogo muestra los errores junto al código.
accountServices.sendPhoneCode = async () => {
    const {data} = await jwtAuthAxios.post('/account/phone_code', {}, { silentErrors: true });
    return data;
};

accountServices.getPhoneCode = async () => {
    const {data} = await jwtAuthAxios.get('/account/phone_code', { silentErrors: true });
    return data;
};

accountServices.verifyPhone = async (code) => {
    const {data} = await jwtAuthAxios.post('/account/verify_phone', { code }, { silentErrors: true });
    return data;
};

export default accountServices;
